import { TheNav, Fotter } from './Home'
import FormationMenu from './FormationMenu'
import SSIAP1 from '../Assets/ssiap2mini.png'
import SSIAPPdf from '../Assets/SSIAP3ranPdf.pdf'
import { Hourglass, Timer } from "lucide-react";
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const sections = [
    { title: "PreRequis", content: "✓ Etre titulaire d’un diplôme S.S.I.A.P. 1, d'une équivalence ou des diplômes 'ERP' et 'IGH' ou des décisions de reconnaissance de qualification professionnelle délivrées par le ministre de l'intérieur en application des articles 3-1 à 3-3,\n ✓ Qualification de secourisme en cours de validité," },
    { title: "Objectifs", content: "Maintenir et actualiser les compétences des agents en sécurité incendie pour assurer une gestion efficace des situations d'urgence." },
    { title: "Taux de réussite et d'abandon", content: "✓ Taux de réussite Non défini \n ✓ Taux d'abandon Non défini"},
    { title: "Méthodes mobilisées", content: "Formateurs habilités et supports de cours." },
    { title: "Modalités d’accès formation", content: "Sous réserve d’avoir les prérequis et en fonction du nombre de candidats." },
    { title: "Modalités d’accès au centre", content: "Accessible par les transports en commun, à 10 min de la station de RER la plus proche à Noisy-le-Grand. En voiture, un parking public est disponible à proximité. Accessible aux personnes en situation de handicap. Contacter le référent handicap pour une réception personnalisée." },
    { title: "Contact", content: "La Francilienne de la Formation Noisy le Grand: \n - Téléphone : 09 52 30 99 38 \n - Email : Direction.francilienne.formation@gmail.com \n La Francilienne de la Formation Rennes: \n - Téléphone : 06 48 75 95 18 \n - Email : lffrennes@gmail.com" },
];

const data = [
    {
        objective: "6ème partie\nREMISE A NIVEAU Chef de service",
        knowledge: [
            "Séquence 1 : Fondamentaux de sécurité incendie",
            "Séquence 2 : Mise en situation d'intervention",
            "Séquence 3 : Prévention",
            "Séquence 4 : Moyens de secours",
            "Séquence 5 : Gestion du PC Sécurité",
            "Séquence 6 : Organisation d'une séance de formation",
            "Séquence 7 : L'équipe de sécurité incendie"
        ],
        duration: "35h",
    }
];
  

export const Ran = () =>{
    return(
        <div className='h-fit undi:pt-[14vh] pt-[22vh] md:pb-[8vh] pb-[3vh] md:px-[100px] px-[40px] flex flex-col justify-between items-center'>
            <div className='w-full flex justify-center items-center'>
                <img src={SSIAP1} alt="SSIAP LOGO" className='h-24 w-24 mr-4 border-4 rounded-full border-black p-0.5'/>
                <h3 className='font-bold text-4xl text-center font-times'>Formation SSIAP 3 Remise à niveau</h3>
            </div>
            <div className='w-full'>
                <FormationMenu sections={sections}/>
            </div>
            <div className='w-[90vw] mx-0 h-fit undi:w-[75vw]'>
                <table className="w-full border border-gray-300 text-left">
                    <thead>
                        <tr className="bg-gray-200 text-red-600">
                            <th className="border border-gray-300 px-4 py-2 text-center" colSpan={3}>CONTENU FORMATION REMISE A NIVEAU AGENT DE SECURITE INCENDIE</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data.map((row, index) => (
                        <tr key={index} className="border border-gray-300">
                        <td className="border border-gray-300 px-4 py-2 font-bold">
                            {row.objective}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                            <ul className="list-disc pl-4">
                            {row.knowledge.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                            </ul>
                        </td>
                        <td className="border border-gray-300 px-4 py-2 font-bold text-red-600">
                            {row.duration}
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <a href={SSIAPPdf} className='mb-10 mt-6 text-lg font-semibold text-[#D72427] text-center w-full'>Télécharger le tableaux ici !</a>

            <div className='h-fit md:px-[100px] px-[40px] flex flex-col justify-between items-center mb-6'>
            <h3 className='font-bold text-4xl mb-2 text-center font-times'>Notre Certification</h3>
                <div className='flex flex-col justify-center items-center'>
                    <p className='text-center mt-1'>Service de sécurité incendie et d'assistance aux personnes (Niveau 03) sous le code <br/> <span className='font-bold uppercase'>RS5643 Ministre de l'interieur et des outre-Mer</span></p>
                    <a href="https://www.francecompetences.fr/recherche/rs/5643/ " target="_blank" rel="noopener noreferrer"><img src="https://aspr-formations.fr/wp-content/uploads/2024/05/logo-france-competences.30a014.png" alt="Logo Qualipi" className='ùd:h-20 h-14 my-3'/></a>
                    <a href="https://www.francecompetences.fr/recherche/rs/5643/ "  target="_blank" rel="noopener noreferrer" className='text-center mt-1 flex justify-center items-center'>Voir la certification <ChevronRightIcon className="h-4 w-4 text-black stroke-[2px]" /></a>
                </div>
            </div>

            <div className='h-fit w-full pt-[5vh] md:pb-[8vh] flex flex-col justify-between items-center'>
                <div className='h-5/6 w-full flex justify-evenly items-center flex-wrap'>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Effectif</h5>
                            <p className='text-center text-lg '>4 à 12 personnes maximum</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Délais d'accès</h5>
                            <p className='text-center text-lg '> 2 à 4 semaines.</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Méthodes D’évalution</h5>
                            <p className='text-center text-lg '>QCM et exercices pratiques</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Tarifs</h5>
                            <p className='text-center text-lg '>Devis personnalisé par le financement.</p>
                        </div>
                    </div>
                    <div className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center my-2'>
                        <Timer className="h-16 w-16 font-medium text-black-500" />
                        <div className='flex flex-col items-center justify-center'>
                            <h5 className='text-xl text-center font-bold'>Durée</h5>
                            <p className='text-center text-lg '>35 heures</p>
                        </div>
                    </div>
                    <a href="/Contact" className='h-[11rem] md:w-[22rem] w-5/6 bg-[#F5F5F7] rounded-2xl px-4 py-6 flex flex-col justify-around items-center cursor-pointer hover:bg-opacity-50'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-16 w-16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                        </svg>
                        <div className='flex flex-col items-center justify-center '>
                            <h5 className='text-xl text-center font-bold'>Dates</h5>
                            <p className='text-center text-lg  flex items-end underline'>Nous contacter pour les dates <ChevronRightIcon className="h-5 w-5 text-black stroke-[2px] mb-0.5" /></p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export const SSIAP3ran = () =>{
    return(
        <>
            <TheNav/>
            <Ran/>
            <Fotter/>
        </>
    );
}